import { LwFormDate } from 'redesign';
import { FieldRenderer } from '../dynamic-field.types';

export const DynamicDateField: FieldRenderer = (field, control, label) => (
  <LwFormDate
    key={field.key}
    name={`${field.key}`}
    label={label}
    control={control}
    rules={{ required: field.rules.required.value }}
  />
);
